import React, { FunctionComponent } from "react";
import SideBar from "./index";
import { Outlet } from "react-router-dom";

const WithSidebar: FunctionComponent = (props: any) => {
  return <SideBar>{props.children ? props.children : <Outlet />}</SideBar>;
};

export default WithSidebar;
